/*
 * vp-pinned-blocks.js
 *
 * Relocates blocks pinned inside a Variant picker block (Sizing chart,
 * Text with icon, Icons with text) into their chosen option slot.
 *
 * Why JS is needed: a theme block nested inside the Variant picker is
 * exposed to the parent Liquid scope with type '@theme' and a settings
 * proxy that returns null for the child's own settings. So the parent
 * loop cannot read each child's "Position" (append) setting to place it.
 * Instead each child renders once — in its own scope, where the setting
 * resolves — inside a hidden `.vp-pinned-holding` div and stamps its
 * position onto a `data-vp-pos` attribute. This script moves each stamped
 * element into the slot whose id is
 *   SizeChartAppend-<sectionId>-<position>
 * which the picker emits for every option (label / below-label / under).
 *
 * Resilience: variant changes replace the whole <variant-selects> element
 * via HTMLUpdateUtility.viewTransition (n.innerHTML = newHTML; remove old).
 * That means (a) any inline script in the new markup won't execute and
 * (b) for ~250ms the old and new pickers coexist with duplicate slot ids.
 * To handle both, this asset is loaded once globally, observes the DOM for
 * new holdings, and scopes every slot lookup to the holding's OWN
 * <variant-selects> ancestor so items never land in the dying old picker.
 */
(function () {
  if (window.__vpPinnedBlocksInit) return;
  window.__vpPinnedBlocksInit = true;

  function relocate() {
    var holdings = document.querySelectorAll('.vp-pinned-holding');
    for (var h = 0; h < holdings.length; h++) {
      var holding = holdings[h];
      var sectionId = holding.getAttribute('data-section');
      if (!sectionId) continue;

      // Scope slot lookup to this holding's own picker so we don't move
      // items into the old (being-removed) picker during a variant-change
      // view transition, where slot ids are momentarily duplicated.
      var scope = holding.closest('variant-selects') || document;

      var items = holding.querySelectorAll(':scope > [data-vp-pos]');
      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        var pos = el.getAttribute('data-vp-pos');
        if (!pos) continue;
        var slotId = 'SizeChartAppend-' + sectionId + '-' + pos;
        var slot = scope.querySelector('[id="' + slotId + '"]');
        if (slot) slot.appendChild(el);
      }
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var run = function () {
      scheduled = false;
      relocate();
    };
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(run);
    } else {
      window.setTimeout(run, 0);
    }
  }

  function init() {
    relocate();
    // A single persistent observer survives <variant-selects> replacement
    // because it is bound to the document, not to the picker element.
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
    // Theme editor: re-place on block/section reloads as belt-and-braces.
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', schedule);
      document.addEventListener('shopify:block:load', schedule);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
